module.exports = __webpack_public_path__ + "img/alex.2cf36451.jpg";